// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { StableToChoose, StableToChooseSchema } from 'api/gen/StableToChoose';

const requiredPart = t.interface({
  content: t.union([t.array(StableToChooseSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelStableToChooseSchema = excess(requiredPart);

export interface PagedModelStableToChoose extends t.TypeOf<typeof PagedModelStableToChooseSchema> {}
